import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const heroImagesCarouselSettings = {
	showStatus: false,
	showThumbs: false,
	infiniteLoop: true,
};

const HeroImages = ({ values }) => {
	if (values.length === 1) {
		return values.map((value, index) => render(value, index));
	} else {
		return (
			<Carousel {...heroImagesCarouselSettings}>
				{values.map((value, index) => render(value, index))}
			</Carousel>
		);
	}
};

const render = (value, index) => {
	return (
		<div className="slider__block" key={`figure${index}`}>
			<img className="slider__image" src={value.image} alt={value.alt} />
			<div className="slider__text-container">
				<h2 className="slider__title">{value.title}</h2>
				<h3 className="slider__text">{value.text}</h3>

				{value.linkUrl && value.linkText && 
					<>
						<a
							className="buttonv2 buttonv2-secondary slider__button"
							href={value.linkUrl}
						>
							{value.linkText}
						</a>
					</>
				}
			</div>
		</div>
	);
};

export default HeroImages;
